<template>
    <div style="max-width:900px; margin: auto;">
        <br />
        <h2>Integration</h2>
     <hr />
    
  <br />
  <div class="seasoncast-card">
    <h5 class="card-header">Refund Request</h5>
    <div style="text-align:left;" class="card-body">
  <p>You may request a refund for your SeasonCast Premium subscription. We will review your request and issue a refund if you are eligible based off of your usage and time since renewal. Warning: SeasonCast at their sole discretion may deactive your account for refunding an active subscription.</p>
  <br />
    <button v-on:click="refundRequest()" type="button"  class="btn btn-secondary btn-block">Request Refund</button>
  
    </div>
  </div>
  
  </div>
  </template>
  <script lang="ts">
  let API = "https://app.seasoncast.com/"

   import Swal from "sweetalert2"
   import axios from 'axios';

  export default {
    name: 'Refund',
    props: ['channel'],
    methods:{
        async refundRequest(){
      const didConfirm = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to continue with requesting a refund? SeasonCast at their sole discretion may deactive your account for refunding an active subscription. Please backup any recordings you wish to keep.",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, I understand.",
      closeOnConfirm: false
    })

    if (!didConfirm.isConfirmed){
      return;
    }
  


      let response = await axios.post(`${API}v2/broadcaster/refund`, {...this.$store.state.broadcasterAuth});
      if (response.data.success){
        Swal.fire("Success!", "Your have been refunded", "success");
        
      }else{
        Swal.fire("Error!", "Due to ether your usage, time since renewal, or other factors, you need to manually request a refund at support@seasoncast.com", "error");
      }
    


  },
},
    components: {
    
    },
    async created() {
    },
  }
  </script>
  